<template>
	<Modal v-model="show" :mask-closable="false" :loading="loading" @on-ok="savePayment">
		<div slot="header" class="modal-header">电表充值</div>
		<Form :model="params" :label-width="85" :rules="recharge" ref="formValidate">
			<FormItem label="表类型：">
            	<span>{{devicetype | formatDeviceType}}</span>
        	</FormItem>
			<FormItem label="单价：">
            	<span>{{params.univalence}}</span>
        	</FormItem>
			<FormItem label="充值示数：" prop="showReading">
            	<Input v-model="params.showReading"  class="item-width" @on-blur="computAmount" :number="true"></Input>
        	</FormItem>
			<FormItem label="充值金额：" prop="amount">
            	<Input v-model="params.amount"  class="item-width" @on-blur="computShowRead" :number="true"></Input>
        	</FormItem>
			<FormItem label="关联合同：" prop="contractId" v-show="this.select.length>0 ">
				<Select v-model="params.contractId" class="item-width">
                    <Option  v-for="item in select" :value="item.contractId" :key="item.contractId">{{item.userName+'('+item.contractNumber+')'}}</Option>
                </Select>
			</FormItem>
		</Form>
	</Modal>
</template>

<script type="text/ecmascript-6">
import { settingsGet } from "api/waterAndElectricity"; //查询单价
import { payment,getContractRecharge } from "api/meterRecharge";
import { getDetails } from "api/meterRecharge";
export default {
	props: {
		projectfid:{
			type:String,
			default:""
		},
		devicetype:{
            type:Number,
            default:null
		},
		roomid:{
			type:String,
			default:""
		},
		count:{
			type:Number,
			default:0
		}
	},
	watch: {
		count() {
			this.clearFrom();
			this.init();
		},
	},
	data () {
		const validateShowReading = (rule, value, callback) => {
			if(!value){
				callback(new Error('设备示数不能为空'));
			}
			if(typeof value === 'string'){
				callback(new Error('请输入正确的示数'));
			}
			if(value < 0){
				callback(new Error('示数不能小于0'));
			}else{
				callback();
			}
		}
		const validateAmount = (rule, value, callback) => {
			if(!value){
				callback(new Error('充值金额不能为空'));
			}
			if(typeof value === 'string'){
				callback(new Error('请输入正确的金额'));
			}
			if(value < 0){
				callback(new Error('金额不能小于0'));
			}else{
				callback();
			}
		}
		return {
			show:false,
			loading:true,
			params:{
				amount:null,
				contractId:'',  //合同id
				deviceType:null, //表类型
				projectFid:"",
				showReading:null,  //充值示数
				roomFid:"",
				univalence:"",  //单价
			},
			recharge:{
				showReading:[
					{ required: true, validator: validateShowReading, trigger: 'change', type:'number'}
				],
				amount:[
					{ required: true, validator: validateAmount, trigger: 'change', type:'number'}
				]
			},
			select:[]
		}
	},
	methods: {
		init(){
			this.getPrice();
			this.isRecharge();
		},
		getPrice() {
			settingsGet({projectFid:this.projectfid}).then(res => {
				if(this.devicetype&&this.devicetype === 0){
					// 水
					this.params.univalence = res.data.cusmoter.lengShui.unitPrice
				}else if(this.devicetype&&this.devicetype === 1){
					//电
					this.params.univalence = res.data.cusmoter.dian.unitPrice
				}

			})
		},
		initSelect(){
			this.select = [];
      getContractRecharge({roomId:this.roomid}).then(res => {
			  if (res.data){
          this.select = res.data;
        } else {
          this.$Message.warning("该房间下无有效合同")
        }
				this.show = true;
			})
		},
		isRecharge(){
			// 充值前判断
			getDetails({roomId:this.roomid,deviceType:this.devicetype}).then(res => {
				// 0 预付费 1 后付费
				if(res.data.paymentType === 1){
					this.$Message.info('该设备为后付费，不支持充值')
				}else{
					this.initSelect();
				}
			})
		},
		computAmount() {
			if(!this.params.univalence&&!this.params.showReading){
				return;
			}
			if(isNaN(this.params.showReading)){
				return;
			}
			if(this.params.showReading <= 0){
				return;
			}
			this.params.amount = Number((this.params.univalence * this.params.showReading).toFixed(2))
		},
		computShowRead() {
			if(!this.params.univalence&&!this.params.amount){
				return;
			}
			if(isNaN(this.params.amount)){
				return;
			}
			if(this.params.amount <= 0){
				return;
			}
			this.params.showReading = Number((this.params.amount / this.params.univalence).toFixed(2));
		},
		initParams() {
			this.params.roomFid = this.roomid;
			this.params.deviceType = this.devicetype;
			this.params.projectFid = this.projectfid;
		},
		changeLoad(){
			this.loading = false;
            this.$nextTick(() => {
                this.loading = true
            })
		},
		clearFrom() {
			this.$refs['formValidate'].resetFields();
		},
		savePayment() {
			this.$refs['formValidate'].validate(bool => {
				if(bool){
					this.$Modal.confirm({
						title:'确认框',
						content:'<h3>请确认充值金额和合同是否正确!</h3>',
						onOk: () => {
							this.initParams();
							payment(this.params).then(res => {
								this.changeLoad();
								this.$Message.success('充值成功');
								this.show = false;
							}).catch(error => {
								this.changeLoad();
							})
						},
						onCancel: () => {
							this.changeLoad();
						}
					})

				}else{
					this.changeLoad();
				}
			})

		}
	}
}
</script>

<style lang="css" scoped>
.item-width{
	width: 200px;
}
</style>
